import { cn } from '@lyearn/style';

import { CounterPillAppearance, CounterPillSize } from './types';

const COUNTER_PILL_SIZE_CLASSES = {
  large: 'h-32',
  medium: 'h-26',
  small: 'h-20',
};

const COUNTER_PILL_TYPOGRAPHY_VARIANT = {
  large: 'label-01',
  medium: 'body-short-02',
  small: 'body-short-03',
};

const COUNTER_PILL_TYPOGRAPHY_COLOR = {
  primary: 'text-text-primary',
  secondary: 'text-text-secondary',
};

const COUNTER_PILL_PADDING_CLASSES = {
  large: 'px-12',
  medium: 'px-10',
  small: 'px-8',
};

export const getCounterPillClasses = (size: CounterPillSize, appearance: CounterPillAppearance) => {
  const sizeClasses = COUNTER_PILL_SIZE_CLASSES[size];
  const typographyVariant = COUNTER_PILL_TYPOGRAPHY_VARIANT[size];
  const typographyColor = COUNTER_PILL_TYPOGRAPHY_COLOR[appearance];
  const paddingClasses = COUNTER_PILL_PADDING_CLASSES[size];

  return {
    label: 'p-0',
    root: cn('bg-bg-tertiary', sizeClasses, typographyVariant, typographyColor, paddingClasses),
  };
};
